import type { FlightSearchWidgetInitialFocus } from 'contexts/Flights/FlightSearchWidget/types'

interface FlightSearchInitialFocusHandlers {
  departureAirport?: (flightId: string) => void
  arrivalAirport?: (flightId: string) => void
  departureDate?: (flightId: string) => void
  returnDate?: (flightId: string) => void
}

export function applyFlightSearchInitialFocus(
  initialFocus: FlightSearchWidgetInitialFocus,
  handlers: FlightSearchInitialFocusHandlers,
) {
  switch (initialFocus.field) {
    case 'departureAirport':
      handlers.departureAirport?.(initialFocus.flightId)
      break
    case 'arrivalAirport':
      handlers.arrivalAirport?.(initialFocus.flightId)
      break
    case 'departureDate':
      handlers.departureDate?.(initialFocus.flightId)
      break
    case 'returnDate':
      handlers.returnDate?.(initialFocus.flightId)
      break
  }
}
